/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { RichTextComponent } from '@msdyn365-commerce/core';
import * as React from 'react';

import { ICookbookTaglineData } from './cookbook-tagline.data';
import { ICookbookTaglineProps } from './cookbook-tagline.props.autogenerated';

/**
 *
 * CookbookTagline component
 * @extends {React.PureComponent<ICookbookTaglineProps<ICookbookTaglineData>>}
 */
class CookbookTagline extends React.PureComponent<
  ICookbookTaglineProps<ICookbookTaglineData>
> {
  private _productCookbookTagLine: string = 'COOKBOOKTAGLINE';
  public render(): JSX.Element | null {
    const content: ICookbookTaglineData = this.props.data;
    if (
      !(
        content &&
        content.productSpecificationData &&
        content.productSpecificationData.result
      )
    ) {
      return null;
    }
    const productAttributes = content.productSpecificationData.result;
    const productAttribute = productAttributes.filter(
      attribute =>
        attribute.Name!.toUpperCase() === this._productCookbookTagLine
    );
    if (
      productAttribute &&
      productAttribute.length &&
      productAttribute[0].TextValue
    ) {
      return (
        <div className='product-attribute-nv'>
          <RichTextComponent
            className='product-attribute-nv-value'
            text={productAttribute[0].TextValue}
          />
        </div>
      );
    }
    return null;
  }
}

export default CookbookTagline;
